import type { ActionResponse, UserResponseWithPinnedTemplateIds } from '../types'
import { apiCall } from './index'

const ENDPOINT = '/api/actions/user'

export async function fetchUser(params?: { uuid: string }): Promise<ActionResponse<UserResponseWithPinnedTemplateIds>> {
  return apiCall<UserResponseWithPinnedTemplateIds>(ENDPOINT, 'fetchUser', params)
}
